import { Component, OnInit } from "@angular/core";
//import { Intercom } from 'ng-intercom';
import { CommonService } from "../shared/common.service";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.css"],
})
export class MainComponent implements OnInit {
  constructor(
    //public intercom: Intercom,
    public Common: CommonService
  ) {}

  ngOnInit() {
    let a = [{ number: 19, value: 110 }];
    for (let i = 1; i < 10; i++) {
      let number = a[0]["number"] - i;
      let value = a[0]["value"] - i * 10;

      a.push({ number: number, value: value });
    }
    // console.log('final',a);

    let user = this.Common.getUser();
    // this.intercom.boot({
    //   app_id: "bn64enia",
    //   name: "Admin", // Full name
    //   email: user.email,
    //   created_at: user.iat ,
    //   // Supports all optional configuration.
    //   widget: {
    //     "activator": "#intercom"
    //   }
    // });
  }
}
